var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12495 4.8752H8.1062L5.0562 1.8252C4.81245 1.58145 4.81245 1.18145 5.0562 0.937695C5.29995 0.693945 5.6937 0.693945 5.93745 0.937695L10.0562 5.05645C10.3 5.3002 10.3 5.69395 10.0562 5.9377L5.93745 10.0564C5.6937 10.3002 5.29995 10.3002 5.0562 10.0564C4.81245 9.8127 4.81245 9.41895 5.0562 9.1752L8.1062 6.1252H1.12495C0.781203 6.1252 0.499953 5.84395 0.499953 5.5002C0.499953 5.15645 0.781203 4.8752 1.12495 4.8752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.97527d0bc691a3e8860b0194e5f983ec.svg";
export { ForwardRef as ReactComponent };